// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import AuditStatusTcsm from '@deere/cps-it.warranty-model-factory/lib/audit-status-tcsm';
import ReportListItem from './report-list-item';

const ReportList = props =>
    <div className='report-list'>
        {props.tcsm.map((item, index) =>
            <ReportListItem
                item={item}
                key={index}
            />
        )}
    </div>;

ReportList.displayName = 'ReportList';
ReportList.propTypes = {
    tcsm: PropTypes.arrayOf(PropTypes.instanceOf(AuditStatusTcsm)).isRequired
};

export default ReportList;



// WEBPACK FOOTER //
// ./src/reports/audit-status/components/report-list/index.js